import {
  string as yupString,
} from 'yup';

import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { hideField } from '../../shared/forms/constants';

const resetCountryTaxType = (_, { formik }) => {
  formik.setFieldTouched('countryTaxType', false);
  formik.setFieldValue('countryTaxType', '');
};

const schema = [
  {
    name: 'companyCode',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'companyCodes' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: {
      virtualized: true, className: 'large',
      onSelect: resetCountryTaxType,
    },
  },
  {
    name: 'taxYear',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'taxYears' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: { virtualized: true, className: 'small' },
  },
  {
    name: 'countryTaxType',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'countryTaxTypes' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: { virtualized: true, className: 'large' },
    conditions: [{
      when: ({ formContext: { isLoadingCountryTaxTypes } }) => isLoadingCountryTaxTypes,
      then: { additionalProps: { loading: true } },
    }],
  },
  {
    name: 'entryType',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'entryTypes' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: { virtualized: true, className: 'medium', clearWhenOptionsChanged: true },
    conditions: [{
      when: ({ formContext: { isLoadingTaxEntriesTree, isLoadingTypeDescriptions } }) =>
        isLoadingTaxEntriesTree || isLoadingTypeDescriptions,
      then: { additionalProps: { loading: true } },
    }],
  },
  {
    name: 'entryActivity',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'entryActivities' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: { virtualized: true, className: 'medium', clearWhenOptionsChanged: true },
    conditions: [{
      when: ({ formContext: { isLoadingTaxEntriesTree, isLoadingActivityDescriptions } }) =>
        isLoadingTaxEntriesTree || isLoadingActivityDescriptions,
      then: { additionalProps: { loading: true } },
    }],
  },
  {
    name: 'bookType',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'bookTypes' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: { virtualized: true, className: 'small', clearWhenOptionsChanged: true },
    conditions: [{
      when: ({ formContext: { isLoadingTaxEntriesTree } }) => isLoadingTaxEntriesTree,
      then: { additionalProps: { loading: true } },
    }],
  },
  {
    name: 'account',
    component: SelectFormik,
    meta: { label: '', optionsKey: 'accounts' },
    options: { yupType: yupString(), validationRules: [] },
    additionalProps: { virtualized: true, className: 'medium', clearWhenOptionsChanged: true },
    conditions: [
      {
        when: ({ formContext }) => formContext.combination.accountOverride,
        then: { additionalProps: { disabled: true } },
      },
      {
        when: ({ formContext }) => !formContext.combination.requireAccount,
        then: hideField,
      },
    ],
  },
];

export default schema;
